import { WebsiteProjectsActions, WebsiteProjectsActionTypes } from './shell.action';
import { WebsiteShellState, initialState } from './shell.state';
import { createSelector, createFeatureSelector } from '@ngrx/store';

export const getProjectsState = createFeatureSelector<WebsiteShellState>('websiteShell');

export const get_defination = createSelector(
    getProjectsState,
    state => state.defination
);

export const get_mega_menu = createSelector(
    getProjectsState,
    state => state.mega_menu
);

export const get_projects = createSelector(
    getProjectsState,
    state => state.projects
);

export const get_seo_projects = createSelector(
    getProjectsState,
    state => state.seo_projects
);

export const get_seo_project = createSelector(
    getProjectsState,
    state => state.project
);

export const get_latest_projects = createSelector(
    getProjectsState,
    state => state.latest_projects
);

export const get_all_projects = createSelector(
    getProjectsState,
    state => state.all_projects
);

export const project_menus = createSelector(
    getProjectsState,
    state => state.project_menus
);

export const get_student_details = createSelector(
    getProjectsState,
    state => state.student_details
);

export const getError = createSelector(
    getProjectsState,
    state => state.error
);

export function WebsiteShellReducer(state = initialState, action: WebsiteProjectsActions): WebsiteShellState {
    switch (action.type) {

        case WebsiteProjectsActionTypes.FETCH_DEFINATION_SUCCESS:
            return {
                ...state,
                defination: action.payload,
                error: { ...state.error, defination_error: null }
            }

        case WebsiteProjectsActionTypes.FETCH_DEFINATION_FAIL:
            return {
                ...state,
                defination: state.defination,
                error: { ...state.error, defination_error: action.payload }
            }

        case WebsiteProjectsActionTypes.FETCH_MEGA_MENU_SUCCESS:
            return {
                ...state,
                mega_menu: action.payload,
                error: { ...state.error, mega_menu_error: null }
            }

        case WebsiteProjectsActionTypes.FETCH_MEGA_MENU_FAIL:
            return {
                ...state,
                mega_menu: state.mega_menu,
                error: { ...state.error, mega_menu_error: action.payload }
            }

        case WebsiteProjectsActionTypes.FETCH_WEBSITE_PROJECTS_SUCCESS:
            return {
                ...state,
                projects: action.payload,
                error: { ...state.error, projects_error: null }
            }

        case WebsiteProjectsActionTypes.FETCH_WEBSITE_PROJECTS_FAIL:
            return {
                ...state,
                projects: state.projects,
                error: { ...state.error, projects_error: action.payload }
            }

        case WebsiteProjectsActionTypes.FETCH_SEO_FILTERED_WEBSITE_PROJECTS_SUCCESS:
            return {
                ...state,
                seo_projects: action.payload,
                error: { ...state.error, seo_projects_error: null }
            }

        case WebsiteProjectsActionTypes.FETCH_SEO_FILTERED_WEBSITE_PROJECTS_FAIL:
            return {
                ...state,
                seo_projects: state.seo_projects,
                error: { ...state.error, seo_projects_error: action.payload }
            }

        case WebsiteProjectsActionTypes.FETCH_SEO_FILTERED_WEBSITE_PROJECT_SUCCESS:
            return {
                ...state,
                project: action.payload,
                error: { ...state.error, project_error: null }
            }

        case WebsiteProjectsActionTypes.FETCH_SEO_FILTERED_WEBSITE_PROJECT_FAIL:
            return {
                ...state,
                project: state.project,
                error: { ...state.error, project_error: action.payload }
            }

        case WebsiteProjectsActionTypes.FETCH_WEBSITE_LATEST_PROJECTS_SUCCESS:
            return {
                ...state,
                latest_projects: action.payload,
                error: { ...state.error, latest_projects_error: null }
            }

        case WebsiteProjectsActionTypes.FETCH_WEBSITE_LATEST_PROJECTS_FAIL:
            return {
                ...state,
                latest_projects: state.latest_projects,
                error: { ...state.error, latest_projects_error: action.payload }
            }

        case WebsiteProjectsActionTypes.FETCH_ALL_PROJECTS_SUCCESS:
            return {
                ...state,
                all_projects: action.payload,
                error: { ...state.error, all_projects_error: null }
            }

        case WebsiteProjectsActionTypes.FETCH_ALL_PROJECTS_FAIL:
            return {
                ...state,
                all_projects: state.all_projects,
                error: { ...state.error, all_projects_error: action.payload }
            }


        case WebsiteProjectsActionTypes.FETCH_WEBSITE_PROJECT_MENUS_SUCCESS:
            return {
                ...state,
                project_menus: action.payload,
                error: { ...state.error, project_menus_error: null }
            }

        case WebsiteProjectsActionTypes.FETCH_WEBSITE_PROJECT_MENUS_FAIL:
            return {
                ...state,
                project_menus: state.project_menus,
                error: { ...state.error, project_menus_error: action.payload }
            }

        case WebsiteProjectsActionTypes.SET_STUDENT_DETAILS:
            return {
                ...state,
                student_details: action.payload,
                error: { ...state.error }
            }

        case WebsiteProjectsActionTypes.FETCH_WEBSITE_PROJECTS:
        case WebsiteProjectsActionTypes.FETCH_MEGA_MENU:
        case WebsiteProjectsActionTypes.FETCH_DEFINATION:
        case WebsiteProjectsActionTypes.FETCH_SEO_FILTERED_WEBSITE_PROJECTS:
        case WebsiteProjectsActionTypes.FETCH_SEO_FILTERED_WEBSITE_PROJECT:
        case WebsiteProjectsActionTypes.FETCH_WEBSITE_LATEST_PROJECTS:
        case WebsiteProjectsActionTypes.FETCH_ALL_PROJECTS:
        case WebsiteProjectsActionTypes.FETCH_WEBSITE_PROJECT_MENUS:
        default:
            return state;
    }
}